/** BSN v4 componentsInit */
export default {};
